import React from 'react';

import WhatsappFlowsListModuleMC from '../../../modules/WhatsappFlows/components/WhatsappFlowsListModuleMC';
import NavbarLayoutMC from '../../../layouts/NavbarLayoutMC';

const WhatsappFlowsScreenMC = () => (
  <NavbarLayoutMC>
    <div className="container-fluid-no-padding px-30 py-20 w-100 bg-white store-content">
      <WhatsappFlowsListModuleMC />
    </div>
  </NavbarLayoutMC>
);

export default WhatsappFlowsScreenMC;
